namespace $ {

	export class $shm_hitalama_map_history_target_events extends $giper_baza_list_link.to(
		()=> $shm_hitalama_map_history_event,
	) {}

}
